/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillingAddress } from './BillingAddress';
export type NewClient = {
    customer_id: string | null;
    given_name: string;
    family_name: string;
    email: string;
    organization_name: string;
    salesperson_email: string | null;
    unit: NewClient.unit;
    interval: NewClient.interval;
    cost: number;
    quantity: number;
    trial_period_days?: number;
    stripe_parent_id: string | null;
    stripe_parent_auth0_id: string | null;
    property_id: string | null;
    address: BillingAddress;
};
export namespace NewClient {
    export enum unit {
        PER_SEAT = 'per_seat',
        PER_UNIT = 'per_unit',
    }
    export enum interval {
        MONTH = 'month',
        YEAR = 'year',
    }
}

